import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import contactimg from "../assets/contactimg.png";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Explore from "./Explore";

const Contact = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div className="contact-blur-top-right-section"></div>
      <div className="container-fluid">
        <div className="contact-section">
          <div className="content-wrapper">
            <div className="curved-gradient-bg"></div>

            <div className="text-content">
              <h1 className="main-title fw-semibold ">
                Here to Help,
                <br />
                Anytime
              </h1>
              <p className="subtitle">Helping you, every step of the way</p>
            </div>

            <div className="image-section">
              <img
                className="person-placeholder"
                src={contactimg}
                alt="Person"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="position-relative w-100"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.9) 9%, #FCF0F1 45% , rgba(255, 255, 255, 0.9) 80%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 "
          // style={{ backgroundColor: "rgba(121, 68, 68, 0.3)", zIndex: "1" }}
        ></div>
        <div className="container position-relative" style={{ zIndex: "1" }}>
          <div className="row justify-content-center mb-5">
            <div className="col-xl-10">
              <div className="bg-light rounded-4 overflow-hidden">
                <div className="row g-0">
                  <div className="col-lg-6 ">
                    <div className="p-2 p-md-5 h-100 d-flex flex-column">
                      <h4 className="fw-semibold" style={{ fontSize: "32px" }}>
                        Contact us
                      </h4>
                      <p className="text-muted mt-4 ">
                        We're not just about numbers—we're about people. Talk to
                        our team and find financial solutions that truly fit
                        your needs.
                      </p>

                      <div className="d-flex flex-column gap-4 mt-4 mb-3">
                        <div className="d-flex align-items-center">
                          <div
                            className="bg-primary text-white rounded-circle p-3 me-3 d-flex justify-content-center align-items-center"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className="fas fa-phone"></i>
                          </div>
                          <p className="text-secondary mb-0">+91 9958853167</p>
                        </div>

                        <div className="d-flex align-items-center">
                          <div
                            className="bg-primary text-white rounded-circle p-3 me-3 d-flex justify-content-center align-items-center"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className="fas fa-envelope"></i>
                          </div>
                          <p className="text-secondary mb-0">
                            shubhpaisa@support.com
                          </p>
                        </div>

                        <div className="d-flex align-items-center">
                          <div
                            className="bg-primary text-white rounded-circle p-3 me-3 d-flex justify-content-center align-items-center"
                            style={{ width: "40px", height: "40px" }}
                          >
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                          <div>
                            <p
                              className="text-secondary mb-0 d-block px-"
                              style={{
                                fontSize: "14px",
                                lineHeight: "1.6",
                                // wordBreak: "break-word",
                              }}
                            >
                              Ithum, Tower-B, 218, Second Floor
                              <br />
                              Sector 62, Noida-201309
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 p-0">
                    <div className="h-100" style={{ minHeight: "400px" }}>
                      <iframe
                     src= "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7004.165748472375!2d77.3673534556453!3d28.627278184318282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f6bf0e729b%3A0x4c68e44d9e70a67f!2sI-Thum%20Tower%20-%20office%20space%20in%20IThum%20Noida%20Sector%2062!5e0!3m2!1sen!2sin!4v1751014402395!5m2!1sen!2sin"
                       width="100%"
                        className="w-100 h-100"
                        style={{ border: "0", minHeight: "400px" }}
                        allowFullScreen=""
                        loading="lazy"
                         referrerPolicy="no-referrer-when-downgrade"
                      ></iframe> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Explore />
      <Footer />
    </>
  );
};

export default Contact;
